<template>
    <div class="mit-home-page mit-page">
        <!-- TODO
        Add my next Reservation(s) widget
        Add Busiest Reservation Times widget -->
        <v-container fluid>
            <BaseMitLoading :show="loadingSpaces || loadingAllSpaces || loadingSave" :overlayFullscreen="false"/>
            <BaseMitReserveEdit :show="dialog" :existingReservation="newReservation" :selectedSpace="newReservationSpace" @cancel="cancelReservation" @save="saveReservation"/>
                <v-card class="mit-info-card" style="width:100%">
                    <v-card-title color="white">Dashboard</v-card-title>
                    <v-card-subtitle class="caption">Reservation Dashboard</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text class="grey lighten-5">
                        <v-row>
                            <v-col col="12" md="6">
                                <v-card class="" elevation="4">
                                    <v-card-title><v-icon class="pr-1" color="red lighten-1">mdi-heart</v-icon>My Favorite Spaces</v-card-title>
                                    <v-card-text>
                                        <MitMyFavoriteSpaces :linkToMapUrl="spacesUrl" :spaces="spaces" @newReservation="reserveSpace" @favoriteChanged="favoriteChanged"/>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col col="12" md="6" v-for="spacesByTypes in spacesAvailableByType" :key="spacesByTypes.type">
                                <v-card class="" elevation="4">
                                    <v-card-title style="text-transform: capitalize;"><v-icon class="pr-1">mdi-clock-outline</v-icon>Available Now - {{spacesByTypes.type.toLowerCase()+'s'}}</v-card-title>
                                    <v-card-text>
                                        <v-simple-table fixed-header height="300px">
                                          <template v-slot:default>
                                            <thead>
                                              <tr>
                                                  <th class="text-left">Space</th>
                                                  <!-- <th class="text-left">Building</th> -->
                                                  <!-- <th class="text-left">Floor</th> -->
                                                  <th class="text-left">Capacity</th>
                                                  <th class="text-left">Available For</th>
                                                  <th class="text-left"></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr v-for="space in spacesByTypes.spaces" :key="space.mitId">
                                                <!-- <td>{{ space.mitId }}</td> -->
                                                <td>
                                                    <a target="_blank" rel="noopener noreferrer" :href="spacesUrl+'/maps/'+space.buildingMitId+'?s='+space.mitId+'&l='+space.level">
                                                        <h4>
                                                            <!-- {{space.name || space.mitId}} -->
                                                            {{space.nameFormatted}}
                                                        </h4>
                                                    </a>
                                                </td>
                                                <!-- <td>{{ space.buildingMitId }}</td> -->
                                                <!-- <td>{{ space.level }}</td> -->
                                                <td>{{ space.maxCapacity }}</td>
                                                <td>{{ space.dates_local.nextStartTimeLeft }}</td>
                                                <td><v-btn class="" small text outlined color="primary" elevation="0" @click="reserveSpace(space)">Reserve</v-btn></td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitReserveEdit from '../../base/components/reserve/BaseMitReserveEdit.vue';

import MitSpacesApiService from '../../base/services/BaseMitReserveSpacesService.js';
import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
import MitReservationService from '../../base/services/BaseMitReserveService.js';

import MitFavoritesService from '../services/MitFavoritesService.js';

import MitMyReservationsSimple from '../components/MitMyReservationsSimple.vue';
import MitMyFavoriteSpaces from '../components/MitMyFavoriteSpaces.vue';
import MitAllSpacesList from '../components/MitAllSpacesList.vue';


  export default {
    name: 'MitDashboardPage',
    components: {
        BaseMitLoading,
        BaseMitDataTable,
        MitMyReservationsSimple,
        MitAllSpacesList,
        BaseMitReserveEdit,
        MitMyFavoriteSpaces
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    data: function() {
      return {
          dialog:false,
          loadingSpaces:true,
          loadingAllSpaces:true,
          loadingSave:false,
          newReservation:null,
          newReservationSpace:null,
          spaces:[],
          spacesAvailable:[],
          spacesAvailableByType:[],
          spacesUrl:null,
          labels: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm',
      ],
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ],
      }
    },
    mounted() {
        this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');
        this.requestCurrentlyAvailableSpaces();
        this.requestAllSpaces();
    },
    methods:{
        favoriteChanged(space){
        if(space.favorite){
            space.favorite = false;
            MitFavoritesService.delete(space.mitId)
            .then((data) => {})
            .catch((error) => {
                this.status.message = 'An error removing favorite '+mitId;
                this.status.display = true;
                this.status.color = 'red';
                console.log('ERROR:', error);
            });
            
        }
        else{
            space.favorite = true;
            MitFavoritesService.save(space.mitId)
                .then((data) => {})
                .catch((error) => {
                    this.status.message = 'There was an error adding favorite '+ mitId;
                    this.status.display = true;
                    this.status.color = 'red';
                    console.log('ERROR:', error);
                });
        }
      },
        myReservationsChanged(){
            this.requestCurrentlyAvailableSpaces();
        },
        reserveSpace(space){
            this.newReservation = MitReservationService.create();
            this.newReservation.mitId = space.mitId;
            this.newReservationSpace = space;
            this.dialog = true;
        },
        cancelReservation(){
            this.dialog = false;
        },
        saveReservation(reservation){
          this.loadingSave = true;

          MitReservationService.save(reservation)
            .then((data) => {
                this.loadingSave = false;
                // this.status.message = 'Saved!',
                // this.status.color = 'primary'
                // this.status.display = true;
                this.dialog = false;
                this.requestCurrentlyAvailableSpaces();
                //this.resetForm();//reset the form values to potentially start over
            })
            .catch((error) => {
                this.loadingSave = false;
                this.dialog = false;
                // this.status.message = error;
                // this.status.display = true;
                // this.status.color = 'red';
                this.errorsSpaces = ['Error getting available spaces from space app.']
                console.log('ERROR:', error);
                //this.resetForm();//reset the form values to potentially start over
            });
        },
        splitSpacesByType(){
            this.spacesAvailableByType = [];
            let spaceTypeDict = {};
            this.spacesAvailable.forEach(
                (s) => {
                    if( !spaceTypeDict[s.useType] ){
                        spaceTypeDict[s.useType] = [];
                    }
                    spaceTypeDict[s.useType].push(s);
                }
            );

            for (let key in spaceTypeDict) {
                if (spaceTypeDict.hasOwnProperty(key)) {
                    this.spacesAvailableByType.push({
                        type:spaceTypeDict[key][0].useType,
                        spaces:spaceTypeDict[key]
                    });
                }
            }
        },
        requestAllSpaces(){
                this.loadingAllSpaces = true;

                MitSpacesApiService.getReservableSpaces()
                  .then((data) => {
                      this.loadingAllSpaces = false;
                      this.spaces = data.spaces;
                  })
                  .catch((error) => {
                      this.loadingAllSpaces = false;
                    //   this.status.message = 'An error occurred trying to get the reservable spaces.';
                    //   this.status.display = true;
                    //   this.status.color = 'red';
                    //   this.errorsSpaces = ['Error getting available spaces from space app.']
                      console.log('ERROR:', error);
                  });
        },
        requestCurrentlyAvailableSpaces(){
                this.loadingSpaces = true;

                MitSpacesApiService.getAvailableSpacesFromNow(15,'m')
                  .then((data) => {
                      this.loadingSpaces = false;
                      this.spacesAvailable = data.spaces;
                      this.splitSpacesByType();
                  })
                  .catch((error) => {
                      this.loadingSpaces = false;
                    //   this.status.message = 'An error occurred trying to get the reservable spaces.';
                    //   this.status.display = true;
                    //   this.status.color = 'red';
                    //   this.errorsSpaces = ['Error getting available spaces from space app.']
                      console.log('ERROR:', error);
                  });
        }
    }

  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
